import { isCanvasContentType } from './contentTypeConstants.ts';

/**
 This function is used in the Content Types header to determine if the Watch dialog should
 appear for a specific content type (i.e whiteboards/databases and any future content types)
 */
export const useIsWatchDialogEnabled = (contentType: string | null | undefined): boolean => {
	return isCanvasContentType(contentType) || contentType === 'database';
};
